/* Vánoční soutěž KLOKI – odpočet, kola, sdílení, konfety. Bez závislostí. */
(function () {
  // Termíny v čase obchodu (Praha, v listopadu a prosinci platí SEČ = +01:00).
  var START = Date.parse('2026-11-16T00:00:00+01:00');
  var KOLA = [
    Date.parse('2026-11-22T23:59:59+01:00'),
    Date.parse('2026-11-29T23:59:59+01:00'),
    Date.parse('2026-12-06T23:59:59+01:00'),
    Date.parse('2026-12-13T23:59:59+01:00'),
    Date.parse('2026-12-16T23:59:59+01:00')
  ];
  // Pro náhled jde hodiny přetočit: ?ted=2026-11-25
  var q = new URLSearchParams(location.search).get('ted');
  var posun = q ? Date.parse(q + 'T12:00:00+01:00') - Date.now() : 0;
  var ted = function () { return Date.now() + posun; };

  function stav() {
    var t = ted();
    if (t < START) return { faze: 'pred', cil: START, kolo: 0 };
    for (var i = 0; i < KOLA.length; i++) if (t <= KOLA[i]) return { faze: 'bezi', cil: KOLA[i], kolo: i + 1 };
    return { faze: 'konec', cil: 0, kolo: 6 };
  }

  // Texty pro JS – každá jazyková verze stránky nastaví window.SOUTEZ_T (výchozí čeština)
  var T = Object.assign({
    pred: 'Soutěž začíná 16. listopadu. Zbývá:',
    bezi: '{k}. kolo končí za:',
    konec: 'Soutěž skončila. Děkujeme všem!',
    st_hotovo: 'Vyhodnoceno', st_bezi: 'Právě běží', st_ceka: 'Čeká',
    zkopirovano: 'Zkopírováno ✓', odkaz: 'Odkaz zkopírován ✓',
    kolo: '{k}. kolo', vyherce_alt: 'Výherce {k}. kola',
    w_bezi: 'Právě soutěžíme', w_vyhl: 'Vyhlašujeme', w_brzy: 'Brzy',
    data: ['16.–22. 11.', '23.–29. 11.', '30. 11.–6. 12.', '7.–13. 12.', '14.–16. 12.']
  }, window.SOUTEZ_T || {});
  var LAB = { pred: T.pred, bezi: function (k) { return T.bezi.replace('{k}', k); }, konec: T.konec };

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tik() {
    var s = stav();
    document.querySelectorAll('[data-cd]').forEach(function (el) {
      var lab = el.querySelector('[data-cd-lab]');
      if (lab) lab.textContent = s.faze === 'bezi' ? LAB.bezi(s.kolo) : LAB[s.faze];
      var box = el.querySelector('.cd');
      if (!box) return;
      if (s.faze === 'konec') { box.hidden = true; return; }
      var d = Math.max(0, s.cil - ted()), sek = Math.floor(d / 1000);
      var h = { d: Math.floor(sek / 86400), h: Math.floor(sek % 86400 / 3600), m: Math.floor(sek % 3600 / 60), s: sek % 60 };
      Object.keys(h).forEach(function (k) {
        var n = box.querySelector('[data-cd-' + k + ']');
        if (n) n.textContent = k === 'd' ? h[k] : pad(h[k]);
      });
    });
    document.querySelectorAll('[data-round]').forEach(function (el) {
      var k = +el.getAttribute('data-round'), st = el.querySelector('.round__s');
      el.classList.toggle('is-now', s.faze === 'bezi' && k === s.kolo);
      el.classList.toggle('is-done', k < s.kolo);
      if (st) st.textContent = k < s.kolo ? T.st_hotovo : (k === s.kolo && s.faze === 'bezi' ? T.st_bezi : T.st_ceka);
    });
  }
  tik(); setInterval(tik, 1000);

  // VÝHERCI: po každém kole doplnit sem (jméno zkráceně, se souhlasem výherce i fotka).
  // Příklad: {kolo: 1, jmeno: 'Petra K.', profil: '@petra.k', foto: 'img/vyherci/k1-petra.webp'}
  var VYHERCI = [];
  var box = document.querySelector('[data-vyherci]');
  if (box) {
    var s0 = stav(), html = '';
    for (var k = 1; k <= 5; k++) {
      var v = VYHERCI.filter(function (x) { return x.kolo === k; });
      if (v.length) {
        v.forEach(function (x) {
          html += '<div class="win"><div class="win__img">' + (x.foto ? '<img src="' + x.foto + '" alt="' + T.vyherce_alt.replace('{k}', k) + '" loading="lazy">' : '<span>🏆</span>') +
            '</div><div class="win__b"><div class="win__k">' + T.kolo.replace('{k}', k) + '</div><div class="win__n">' + x.jmeno + '</div>' +
            (x.profil ? '<div class="win__s">' + x.profil + '</div>' : '') + '</div></div>';
        });
      } else {
        var txt = s0.kolo === k && s0.faze === 'bezi' ? T.w_bezi : (k < s0.kolo ? T.w_vyhl : T.w_brzy);
        html += '<div class="win is-wait"><div class="win__img"><span>🎁</span></div><div class="win__b"><div class="win__k">' + T.kolo.replace('{k}', k) +
          '</div><div class="win__n">' + txt + '</div><div class="win__s">' + T.data[k - 1] + '</div></div></div>';
      }
    }
    box.innerHTML = html;
  }


  // Kopírování textu (např. @kloki.cz) s potvrzením na tlačítku
  document.querySelectorAll('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var txt = b.getAttribute('data-copy'), puv = b.innerHTML;
      (navigator.clipboard ? navigator.clipboard.writeText(txt) : Promise.reject()).catch(function () {}).finally(function () {
        b.textContent = T.zkopirovano;
        setTimeout(function () { b.innerHTML = puv; }, 1800);
      });
    });
  });


  // Tlačítka Instagram/Facebook: na telefonu zkusit otevřít aplikaci, jinak web
  var mobil = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  document.querySelectorAll('[data-app]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!mobil) return;
      e.preventDefault();
      var web = a.href, start = Date.now();
      location.href = a.getAttribute('data-app');
      setTimeout(function () { if (!document.hidden && Date.now() - start < 2500) location.href = web; }, 1200);
    });
  });

  // Sdílení: nativní sdílení na mobilu, jinak zkopírovat odkaz
  document.querySelectorAll('[data-share]').forEach(function (b) {
    b.addEventListener('click', function () {
      var url = b.getAttribute('data-share') || location.href, txt = b.getAttribute('data-share-text') || document.title;
      if (navigator.share) { navigator.share({ title: document.title, text: txt, url: url }).catch(function () {}); return; }
      var puv = b.innerHTML;
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).catch(function () {}).finally(function () {
        b.textContent = T.odkaz; setTimeout(function () { b.innerHTML = puv; }, 1800);
      });
    });
  });

  // Konfety po naskenování (jen stránka sken, respektuje omezení animací)
  var cv = document.querySelector('[data-konfety]');
  if (cv && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var c = cv.getContext('2d'), W, H, kusy = [], barvy = ['#F6D26B', '#FFF0AE', '#DB077A', '#33A3FF', '#FFD43B', '#ffffff'];
    var fit = function () { W = cv.width = cv.offsetWidth * devicePixelRatio; H = cv.height = cv.offsetHeight * devicePixelRatio; };
    fit(); addEventListener('resize', fit);
    for (var i = 0; i < 140; i++) kusy.push({
      x: W / 2 + (Math.random() - .5) * W * .3, y: H * .35, vx: (Math.random() - .5) * 14 * devicePixelRatio,
      vy: (-Math.random() * 16 - 6) * devicePixelRatio, r: (4 + Math.random() * 5) * devicePixelRatio,
      a: Math.random() * 6, va: (Math.random() - .5) * .3, b: barvy[i % barvy.length]
    });
    var t0 = performance.now();
    (function krok(t) {
      c.clearRect(0, 0, W, H);
      kusy.forEach(function (p) {
        p.vy += .35 * devicePixelRatio; p.vx *= .99; p.x += p.vx; p.y += p.vy; p.a += p.va;
        c.save(); c.translate(p.x, p.y); c.rotate(p.a); c.fillStyle = p.b; c.fillRect(-p.r / 2, -p.r / 4, p.r, p.r / 2); c.restore();
      });
      if (t - t0 < 4500) requestAnimationFrame(krok); else c.clearRect(0, 0, W, H);
    })(t0);
  }
})();
